(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/quick-bets.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/quick-bets.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo
} = React;
const logger = svs.core.log.getLogger('components:oddset:quick-bets');
const Brand = svs.ui.ReactBrand;
const {
  common: {
    utils: {
      sortOffers,
      removeDuplicates,
      splitBetOffers
    },
    getSportQuickBetConfig
  },
  QuickBetSection,
  SkeletonLoader,
  EmptyState
} = svs.components.oddset.quickBets;
const {
  useKambiBetOffers
} = svs.components.oddset.kambiOffering.hooks;
const {
  QuickBetButton
} = svs.components.oddset.quickBets;
const QuickBets = _ref => {
  let {
    className = '',
    kambiEventId,
    sportType,
    stickyBottomButton
  } = _ref;
  const {
    quickPlayConfig,
    betOfferTypes
  } = useMemo(() => {
    const quickPlayConfig = getSportQuickBetConfig(sportType);
    const betOfferTypes = removeDuplicates(quickPlayConfig.map(section => section.betOfferType));
    return {
      quickPlayConfig,
      betOfferTypes
    };
  }, [sportType]);
  const englishLabelsArr = useMemo(() => quickPlayConfig.map(section => section.englishLabel), [quickPlayConfig]);
  const {
    betOffers,
    isLoading,
    error
  } = useKambiBetOffers({
    kambiEventId,
    betOfferTypesArr: betOfferTypes,
    englishLabelsArr,
    shouldConnectSockets: svs.core.detect.feature('ft-tipsen-quickbet-sockets')
  });
  const quickBetOfferSections = useMemo(() => {
    if (!Object.values(betOffers).length) {
      return [];
    }
    const sectionsWithOffers = quickPlayConfig.map(section => {
      const offers = Object.values(betOffers).filter(betOffer => betOffer.englishLabel === section.englishLabel);
      if (!offers.length) {
        return null;
      }
      const splitOffers = splitBetOffers(offers);
      return _objectSpread(_objectSpread({}, section), {}, {
        deepLinkPath: offers[0].deepLinkPath,
        definition: section,
        title: offers[0].label,
        offers: sortOffers(splitOffers, section.betOfferType)
      });
    }).filter(section => section !== null);
    if (!sectionsWithOffers.length) {
      logger.info("No betoffers found on event ".concat(kambiEventId, " with betOffer types: ").concat(betOfferTypes.join(',')));
    }
    return sectionsWithOffers;
  }, [betOffers, quickPlayConfig, betOfferTypes, kambiEventId]);
  if (error) {
    throw error;
  }
  if (isLoading && quickBetOfferSections.length === 0) {
    return React.createElement(SkeletonLoader, {
      className: className,
      sections: quickPlayConfig
    });
  }
  if (quickBetOfferSections.length === 0 || !quickPlayConfig) {
    return React.createElement(EmptyState, null);
  }
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: ['quick-bets', className].join(' ')
  }, React.createElement(Brand, {
    brand: "oddset-inverted",
    className: "quick-bets__oddset-logo",
    emblem: true,
    size: 100
  }), React.createElement("h2", {
    className: "quick-bets__header"
  }, "Du kan ocks\xE5 spela live p\xE5 matchen p\xE5 Oddset"), quickBetOfferSections.map(section => React.createElement(QuickBetSection, {
    betOffers: section.offers,
    cssModifier: section.cssModifier,
    key: section.definition.englishLabel,
    sectionTitle: section.title
  })), !stickyBottomButton && React.createElement(QuickBetButton, {
    ariaLabel: "Till Oddset",
    path: quickBetOfferSections[0].deepLinkPath,
    trackingLabel: "Till Oddset"
  }, "Till Oddset")), stickyBottomButton && React.createElement("div", {
    className: "quick-bets-sticky-btn-holder"
  }, React.createElement(QuickBetButton, {
    ariaLabel: "Till Oddset",
    path: quickBetOfferSections[0].deepLinkPath,
    trackingLabel: "Till Oddset"
  }, "Till Oddset")));
};
setGlobal('svs.components.oddset.quickBets.QuickBets', QuickBets);

 })(window);